import http from '@/http/aisea/axios'
const resource = "/enterprises/manning/vessels/crews/scheduler/crew/summary/columns";

export default {

  get() {
    return http.get(`${resource}`);
  },

};
